import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { GLOBAL_VARIABLES } from '../../data/const.data';

@Component({
  selector: 'app-html-content-form',
  templateUrl: './html-content-form.component.html',
  styleUrls: ['./html-content-form.component.css']
})
export class HtmlContentFormComponent implements OnInit, OnDestroy {

  @Input() header: string;
  @Input() content : string;
  @Output() onSubmitted = new EventEmitter<string>();
  @Output() onCancelled = new EventEmitter<boolean>();

  initProps = GLOBAL_VARIABLES.TINY_MCE_INIT_PROPS;

  // TODO: Add sanitizer
  constructor(
  ) {

  }

  ngOnDestroy() {

  }

  ngOnInit() {

  }

  onSubmit() {
    this.onSubmitted.emit(this.content);
  }

  onCancel() {
    this.onCancelled.emit(true);
  }


}
